import { Component, OnInit, EventEmitter, Output, ViewChild, ChangeDetectorRef, Input, TemplateRef } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { FormBuilder, FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { EntitiesFacade } from 'src/app/abstraction/entities.facade';
import { Router } from '@angular/router';
import { GeneralService } from 'src/app/core/services/general.service';
import { TypeDocument } from 'src/app/shared/models/typeDocument';
import { Subscription } from 'rxjs';
import { Patient, PatientLight } from 'src/app/shared/models/patient';
import { PatientEntities } from 'src/app/shared/models/patientEnttities';
import { Address } from 'src/app/shared/models/address';
import { AddressData, Location } from 'src/app/shared/models/location';
import { Province } from 'src/app/shared/models/province';
import { CasesService, PatchPatientBody } from '../../../../core/services/cases.service';
import { Case } from 'src/app/shared/models/case';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ROUTES } from 'src/app/core/enums/routes';
import { PostPatientBody } from '../../../../core/services/cases.service';
import Swal from 'sweetalert2';
import { ExperienceI18nService } from 'src/app/core/experience/experience-i18n.service';
import { PatientsQPS, PatientsService, ProvinceQPS } from '../../../../core/services/patients.service';
import { PatientContact } from '../../../../shared/models/patient';
import { RequisitionsFacade } from '../../../../abstraction/requisitions.facade';
import { CustomValidators } from '../../../../core/validators/custom-validators';
import moment from 'moment';
import { PostRequisitionBody } from 'src/app/core/services/requisition.service';
import { RequisitionTypes } from '../../../../core/enums/requisitionTypes';
import { CasesFacade } from 'src/app/abstraction/cases.facade';

@Component({
    selector: 'app-patient-data',
    templateUrl: './patient-data.component.html',
    styleUrls: ['./patient-data.component.scss'],
})
export class PatientDataComponent implements OnInit {

    // Only Popup mode
    @Input() patientIN: Patient | PatchPatientBody | string;
    @Input() isloadingUpdate: boolean = false;
    @Input() parentComponent: string
    @Input() case: Case;
    @Input() onClickConfirm: boolean;

    @Output() onClickCancelEditPatient = new EventEmitter();
    @Output() onClickConfirmEditPatient = new EventEmitter();
    @Output() isValidatingDocumentNumber = new EventEmitter<boolean>();
    @Output() emitCase = new EventEmitter<Case>();
    @Output() confirmChangesEmitter = new EventEmitter<void>();


    loadingPatient: boolean = false;
    isPatientInputParam: boolean = false;
    //

    @Output() patientData = new EventEmitter<PostPatientBody>();
    @Output() formPatientDataValid = new EventEmitter<boolean>();
    formPatienValid: boolean = false;

    btn_addPhone_disabled: boolean = false;
    btn_addEmail_disabled: boolean = false;
    patientAdmission: PostPatientBody;

    public readonly PATIENT_SEARCH = 'patientSearch';
    public readonly PATIENT_SEARCHING = 'patientSearching';
    public readonly PATIENT_NAME = 'name';
    public readonly PATIENT_SURNAME = 'surname';
    public readonly PATIENT_TYPEDOCUMENT = 'typeDocument';
    public readonly PATIENT_DOCUMENTNUMBER = 'documentNumber';
    public readonly PATIENT_BIRTHDATE = 'birthDate';
    public readonly PATIENT_AGE = 'age';
    public readonly PATIENT_ADDRESS = 'address';
    public readonly PATIENT_ADDRESS_STREET = 'street';
    public readonly PATIENT_WITHOUT_STREET_NUMBER = 'withoutNumber'
    public readonly PATIENT_ADDRESS_STREETNUMBER = 'streetNumber';
    public readonly PATIENT_ADDRESS_FLOOR = 'floor';
    public readonly PATIENT_ADDRESS_FLAT = 'flat';
    public readonly PATIENT_ADDRESS_FLATEXTRA = 'flatExtra';
    public readonly PATIENT_ADDRESS_LOCATION = 'location';
    public readonly PATIENT_ADDRESS_LOCATION_SEARCHING = 'locationSearching';
    public readonly PATIENT_ADDRESS_STATE = 'state';
    public readonly PATIENT_ADDRESS_STATE_SEARCHING = 'stateSearching';
    public readonly PATIENT_ADDRESS_ZIPCODE = 'zipCode';
    public readonly PATIENT_GENDER = 'gender';
    public readonly PATIENT_HEALTHINSURANCE = 'healthInsuranceId';
    public readonly PATIENT_ADDRESS_LATITUDE = 'latitude';
    public readonly PATIENT_ADDRESS_LONGITUDE = 'longitude';

    // NEW CONTACT
    public readonly PATIENT_NEW_CONTACT_ID = 'id'
    public readonly PATIENT_NEW_CONTACT_PHONE = 'phoneNumber';
    public readonly PATIENT_NEW_CONTACT_EMAIL = 'email';
    public readonly PATIENT_NEW_CONTACT_REFERENCE = 'reference';
    public readonly PATIENT_NEW_CONTACT_MAINCONTACT = 'isMainContact';

    btn_addContact_disabled: boolean = true;

    formSelectTask: FormGroup;

    isLoadingGettingPatients$: Observable<boolean>;
    isLoadingGettingTypeDocuments$: Observable<boolean>;
    formPatient: FormGroup;

    typeDocuments: TypeDocument[];
    _typeDocuments: Subscription;
    visibleNewPatient: boolean = true;
    formAddress: FormGroup;
    formContacts: FormGroup;
    patientsList: Patient[];
    indexMainContact: number = 0;
    caseActive: Case;
    patientSelected: Patient;
    formPatientCaseActive: FormGroup;
    locations: Location[]; _locations: Subscription;
    closedCaseDate;
    closedCase: Case;

    public readonly PATIENT_NAME_CASE_ACTIVE = 'nameCaseActive';
    public readonly PATIENT_OPERATOR_CASE_ACTIVE = 'operatorCaseActive';
    public routes = ROUTES;

    @ViewChild('patientCaseActive', { static: true }) patientCaseActive: TemplateRef<any>;
    @ViewChild('selectTask', { static: true }) selectTask: TemplateRef<any>;

    _dialogRef;
    admissionPatientForm: FormGroup;
    provinceSelected: Province;
    locationSelected: Location;
    address_WithoutNumber: boolean;
    provincesOnSelect: Province[]; _provinces: Subscription;
    actualPatientLocation;
    actualPatientProvince;
    selectedTask: string;
    selectedProvince: string;
    selectedCity: string;
    locationToInputAddress: Address;
    private _selectedlocation: AddressData;
    patientWithoutNumberCheck: boolean = false;
    patientWithoutStreetNumber: boolean = false;

    get selectedLocation() {
        return this._selectedlocation
    }

    set selectedLocation(value: AddressData | null) {
        if (!value) {
            this._selectedlocation = null;
            return;
        }

        this._selectedlocation = value;

        // concatena “Calle Nº”
        const full = [value.street, value.streetNumber]
            .filter(v => v != null && v !== '')
            .join(' ');

        // parchea los dos controles
        this.formAddress.patchValue({
            [this.PATIENT_ADDRESS_STREET]: full,
            [this.PATIENT_ADDRESS_STREETNUMBER]: value.streetNumber ?? ''
        });

        this.formAddress.get(this.PATIENT_ADDRESS_LATITUDE)?.setValue(value.latitude);
        this.formAddress.get(this.PATIENT_ADDRESS_LONGITUDE)?.setValue(value.longitude);
    }


    /*     casesFacade: CasesFacade; */

    get patientTypeDocument() {
        return this.formPatient.get(this.PATIENT_TYPEDOCUMENT).value;
    }
    get patientDocumentNumber() {
        return this.formPatient.get(this.PATIENT_DOCUMENTNUMBER);
    }
    get patientName() {
        return this.formPatient.get(this.PATIENT_NAME).value;
    }
    get patientGender() {
        return this.formPatient.get(this.PATIENT_GENDER).value;
    }
    get patientBirthdate() {
        return this.formPatient.get(this.PATIENT_BIRTHDATE).value;
    }
    get patientAge() {
        return this.formPatient.get(this.PATIENT_AGE).value;
    }
    set patientAge(value) {
        this.formPatient.controls[this.PATIENT_AGE].setValue(value);
    }
    get patientSurname() {
        return this.formPatient.get(this.PATIENT_SURNAME).value;
    }
    get patientStreet() {
        return this.formPatient.get(this.PATIENT_ADDRESS_STREET).value;
    }

    get addressWithoutNumber() {
        return this.formPatient.get(this.PATIENT_WITHOUT_STREET_NUMBER).value
    }

    get patientStreetNumber() {
        return this.formPatient.get(this.PATIENT_ADDRESS_STREETNUMBER).value;
    }
    get patientFlat() {
        return this.formPatient.get(this.PATIENT_ADDRESS_FLAT).value;
    }
    get patientFlatExtra() {
        return this.formPatient.get(this.PATIENT_ADDRESS_FLATEXTRA).value;
    }
    get patientFloor() {
        return this.formPatient.get(this.PATIENT_ADDRESS_FLOOR).value;
    }
    get healthInsurance() {
        return this.formPatient.get(this.PATIENT_HEALTHINSURANCE).value;
    }
    get patientLocation() {
        return this.formPatient.get(this.PATIENT_ADDRESS_LOCATION).value;
    }
    get patientState() {
        return this.formAddress.get(this.PATIENT_ADDRESS_STATE).value;
    }
    get patientZipcode() {
        return this.formAddress.get(this.PATIENT_ADDRESS_ZIPCODE);
    }
    get contacts(): FormArray {
        return this.formContacts.get('contacts') as FormArray;
    }

    get lat() {
        return this.formAddress.get(this.PATIENT_ADDRESS_LATITUDE).value;
    }

    get lng() {
        return this.formAddress.get(this.PATIENT_ADDRESS_LONGITUDE).value;
    }

    set lat(value) {
        this.formAddress.get(this.PATIENT_ADDRESS_LATITUDE).setValue(value)
    }

    set lng(value) {
        this.formAddress.get(this.PATIENT_ADDRESS_LONGITUDE).setValue(value);
    }

    originalFormAddress: {};
    isValidFormPatient: boolean = false; isValidFormAddress: boolean = false; isValidFormContacts: boolean = false;
    isFormContactsTouched: boolean = false;
    RequisitionTypes = RequisitionTypes;

    constructor(
        private formBuilder: FormBuilder,
        private entitiesFacade: EntitiesFacade,
        public router: Router,
        private generalService: GeneralService,
        private casesService: CasesService,
        private casesFacade: CasesFacade,
        public dialog: MatDialog,
        private changeDetector: ChangeDetectorRef,
        private requisitionFacade: RequisitionsFacade,
        private patientsService: PatientsService,
        private experienceI18n: ExperienceI18nService) {
        this.isLoadingGettingPatients$ = this.entitiesFacade.isLoadingGettingPatients$();
        this.isLoadingGettingTypeDocuments$ = this.entitiesFacade.isLoadingGettingTypeDocuments$();
    }

    ngOnInit(): void {

        this.patientAdmission = {};
        this.locationToInputAddress = null;

        if (!!this.patientIN) {
            if (this.isPatient(this.patientIN)) {
                this.selectedCity = this.patientIN.address.location.name;
                this.selectedProvince = this.patientIN.address.location.province.name;
                this.actualPatientProvince = this.patientIN.address.location.province;
                this.actualPatientLocation = this.patientIN.address.location;
                this.locationToInputAddress = this.patientIN.address;
            } else {
                // Resto de casos: string, null, sin address, etc.
                console.log('No es un Patient con address de tipo objeto');
            }
            this.loadingPatient = true
            this.isPatientInputParam = true;
        }

        this.calculateNamePatient.bind(this);
        this._typeDocuments = this.entitiesFacade.getTypeDocuments$().subscribe(typeDocuments => {
            if (!!typeDocuments) {
                this.typeDocuments = typeDocuments;
            } else {
                this.entitiesFacade.loadTypeDocuments();
            }
        })
        this._provinces = this.entitiesFacade.getProvinces$().subscribe(provinces => {
            if (!!provinces) {
                this.provincesOnSelect = provinces;
                if (!!this.actualPatientProvince && !this.provinceSelected) {
                    this.selectProvince(this.actualPatientProvince.id);
                }
            } else {
                this.entitiesFacade.loadProvinces();
            }
        })
        this.formPatient = this.createForm();
        this.formAddress = this.createAddressForm();
        this.originalFormAddress = this.formAddress.value; // After compare

        // PATIENT
        this.formPatient.valueChanges.subscribe(patient => {

            if (this.formPatient.status === 'VALID') {
                const { age, ...newPatient } = patient; // Delete age
                this.patientAdmission = { ...this.patientAdmission, ...newPatient, typeDocument: { id: this.formPatient.get('typeDocument').value }, documentNumber: this.formPatient.get('documentNumber').value };
                this.patientData.emit(this.patientAdmission);
                this.isValidFormPatient = true; // Form valid
            } else {
                this.isValidFormPatient = false; // Form invalid
            }
            this.emitValidsForms()
        })

        // ADDRESS
        this.formAddress.valueChanges.subscribe(_ => {

            if (this.formAddress.status === 'VALID') {
                this.patientAdmission.address = this.generalService.compareObjects(this.formAddress.value, this.originalFormAddress) ? {} : this.formAddress.value;
                // if (!!this.patientAdmission.address) {
                //     this.locationToInputAddress = this.patientAdmission.address
                // }
                const idLocation = this.locationSelected ? this.locationSelected?.id : this.patientSelected?.address?.location ? this.patientSelected?.address?.location.id : null;
                let newPatientAdmissionAddress: any = { ...this.patientAdmission.address, location: { id: idLocation } };
                const { state, zipCode, stateSearching, locationSearching, ...editnewPatientAdmissionAddress } = newPatientAdmissionAddress;
                editnewPatientAdmissionAddress.street = this.selectedLocation?.street ? this.selectedLocation?.street : this.patientAdmission.address.street;

                const withoutNumberValue = this.formAddress.get(this.PATIENT_WITHOUT_STREET_NUMBER)?.value;
                this.patientAdmission.address = {
                    ...editnewPatientAdmissionAddress,
                    withoutNumber: Boolean(withoutNumberValue === true)
                };

                this.patientData.emit(this.patientAdmission);
                this.isValidFormAddress = true; // Form valid
            } else {
                if (this.formAddress.status != 'DISABLED')
                    this.isValidFormAddress = false; // Form invalid
            }
            this.emitValidsForms()
        })

        // CONTACTS
        this.formContacts.valueChanges.subscribe(_ => {

            this.isFormContactsTouched = true;
            const contactsValue = this.contacts.getRawValue()?.filter(c => c.email || c.phoneNumber);

            if (this.formContacts.status === 'VALID') {

                this.patientAdmission.contacts = contactsValue;
                const mainContact = this.getMainContact(contactsValue);
                this.patientAdmission.email = mainContact?.email ?? null;
                this.patientData.emit(this.patientAdmission);
                this.isValidFormContacts = true; // Form valid
            } else {
                this.isValidFormContacts = false; // Form invalid
            }

            this.emitValidsForms()
            this.btn_addContact_disabled = this.isContactInvalid(); // At least phone or email
        })

        setTimeout(() => {
            if (this.isPatientInputParam)
                this.selected(this.patientIN);
        }, 1000);
    }

    emitValidsForms() {

        // if ( !this.isContactInvalid() ) {
        if (this.isValidFormPatient && this.isValidFormAddress) {

            if (!this.isFormContactsTouched || this.isValidFormContacts) {
                this.formPatienValid = true;
                this.formPatientDataValid.emit(true)
            } else {
                this.formPatienValid = false;
                this.formPatientDataValid.emit(false)
            }
        } else {
            this.formPatienValid = false;
            this.formPatientDataValid.emit(false)
        }
        // } else {
        //     this.formPatienValid = false;
        //     this.formPatientDataValid.emit(false)
        // }
    }

    isContactInvalid(): boolean {
        const contactsValue = this.contacts.getRawValue();
        if (!!contactsValue && contactsValue.length > 0) {
            return contactsValue.some(p => !p.email && !p.phoneNumber)
        } else {
            return false;
        }
    }

    getMainContact(contacts: PatientContact[]): PatientContact {
        if (!!contacts && contacts.length > 0) {
            return contacts.find(c => c.isMainContact);
        }
        return null;
    }

    ngOnDestroy(): void {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this._typeDocuments.unsubscribe();

        if (!!this._locations) {
            this._locations.unsubscribe();
        }

        if (!!this._provinces) {
            this._provinces.unsubscribe();
        }

        this.changeDetector.detach();
    }

    loadPatientsByFullName = (value: string) => {
        const pfp: PatientsQPS = {
            active: true
        };
        if (this.generalService.stringIsNumber(value)) {
            pfp['document_number_like'] = value;
        } else {
            pfp['fullName_like'] = value;
        }
        return this.entitiesFacade.loadPatientsLight(pfp);
    }

    createForm(patient?: Patient): FormGroup {
        let radioButton = 'S/E';
        this.admissionPatientForm = this.formBuilder.group({
            [this.PATIENT_SEARCH]: [''],
            [this.PATIENT_SEARCHING]: [''],
        })

        const form = this.formBuilder.group({
            [this.PATIENT_TYPEDOCUMENT]: ['',], // [CustomValidators.required('Tipo documento requerido')]
            [this.PATIENT_DOCUMENTNUMBER]: ['', [Validators.pattern('^[0-9]*$')]], // [CustomValidators.required('Nº de documento requerido')]
            [this.PATIENT_NAME]: [patient && patient.name ? patient.name : '',], // [CustomValidators.required('Nombre requerido')]
            [this.PATIENT_SURNAME]: [patient && patient.surname ? patient.surname : '',], // [CustomValidators.required('Apellido requerido')]
            [this.PATIENT_BIRTHDATE]: [patient && patient.birthDate ? patient.birthDate : ''],
            [this.PATIENT_AGE]: [patient && patient.birthDate ? this.calculateAge(patient?.birthDate) : ''],
            [this.PATIENT_GENDER]: new FormControl({ value: patient && patient.gender ? patient.gender : 'S/E', disabled: false }),
        });

        this.formContacts = this.formBuilder.group({
            contacts: this.formBuilder.array([]) // Definiendo el FormArray de contactos
        });

        form.disable();
        return form;
    }

    private readonly flatExtraLength: number = 200
    createAddressForm(address?: Address): FormGroup {
        const form = this.formBuilder.group({
            [this.PATIENT_ADDRESS_STREET]: [address && address.street ? address.street : '',], // [CustomValidators.required(this.experienceI18n.translate('modules.admissions.patient-data.create-address-form.validators.required', undefined, 'Campo obligatorio'))]
            [this.PATIENT_WITHOUT_STREET_NUMBER]: [address && address.withoutNumber ? address.withoutNumber : false,],
            [this.PATIENT_ADDRESS_STREETNUMBER]: [address && address.streetNumber ? address.streetNumber : '',], // [CustomValidators.required(this.experienceI18n.translate('modules.admissions.patient-data.create-address-form.validators.required', undefined, 'Campo obligatorio'))]
            [this.PATIENT_ADDRESS_FLOOR]: [address && address.floor ? address.floor : '', [CustomValidators.number(this.experienceI18n.translate('shared.text-input.solo-puede-ingresar-numeros', undefined, 'Solo puede ingresar números'))]],
            [this.PATIENT_ADDRESS_FLAT]: [address && address.flat ? address.flat : '',],
            [this.PATIENT_ADDRESS_FLATEXTRA]: [address && address.flatExtra ? address.flatExtra : '', [CustomValidators.maxLength(this.flatExtraLength, this.experienceI18n.translate('modules.admissions.patient-data.create-address-form.validators.max-length', {length: this.flatExtraLength}, ('El máximo de carácteres son' + ' ' + this.flatExtraLength)))]],
            [this.PATIENT_ADDRESS_STATE]: ['', [CustomValidators.required(this.experienceI18n.translate('modules.admissions.patient-data.create-address-form.validators.required', undefined, 'Campo obligatorio'))]],
            [this.PATIENT_ADDRESS_STATE_SEARCHING]: [''],
            [this.PATIENT_ADDRESS_LOCATION]: ['', [CustomValidators.required(this.experienceI18n.translate('modules.admissions.patient-data.create-address-form.validators.required', undefined, 'Campo obligatorio'))]],
            [this.PATIENT_ADDRESS_LOCATION_SEARCHING]: [''],
            [this.PATIENT_ADDRESS_ZIPCODE]: [''],
            [this.PATIENT_ADDRESS_LATITUDE]: [''],
            [this.PATIENT_ADDRESS_LONGITUDE]: [''],
        });
        form.disable();
        return form;
    }

    resetAddressFields(exceptField?: string) {
        // Definir el objeto con todos los campos que deben resetearse a null
        const defaultValues = {
            [this.PATIENT_ADDRESS_LOCATION]: null,
            [this.PATIENT_ADDRESS_ZIPCODE]: null,
            [this.PATIENT_ADDRESS_FLOOR]: null,
            [this.PATIENT_ADDRESS_FLAT]: null,
            [this.PATIENT_ADDRESS_FLATEXTRA]: null
        };

        // Si hay un campo que no debe ser null, lo excluimos del reset
        if (exceptField && defaultValues.hasOwnProperty(exceptField)) {
            defaultValues[exceptField] = this.formAddress.get(exceptField)?.value;
        }

        // Si exceptField tiene valor, mantener también el valor de ZIPCODE
        if (exceptField) {
            defaultValues[this.PATIENT_ADDRESS_ZIPCODE] = this.formAddress.get(this.PATIENT_ADDRESS_ZIPCODE)?.value;
        }

        // Aplicar los valores
        this.formAddress.patchValue(defaultValues);
    }

    //GUARDAMOS CALLE Y NUMERO EN EL FORMADDRESS
    onSelectAddress(event: AddressData | null) {
        if (!event) {
            this.patientWithoutStreetNumber = false;
            this.patientWithoutNumberCheck = false;
            this._selectedlocation = null;
            return;
        }

        if (event.streetNumber !== '') {
            this.patientWithoutStreetNumber = false;
            this.patientWithoutNumberCheck = false;
            this.deleteTag()
        } else {
            this.patientWithoutStreetNumber = true;
            this.patientWithoutNumberCheck = false;
            this.formAddress.patchValue({
                [this.PATIENT_ADDRESS_FLOOR]: "",
                [this.PATIENT_ADDRESS_FLAT]: "",
            });
        }

        this.selectedLocation = event;
    }

    //Si LA DIRECCIÓN ES EDITADA Y TIENE NÚMERO : BORRAMOS LA ETIQUETA 'SIN NÚMERO' DE OBSERVACIONES
    deleteTag() {
        const originalValue = this.formAddress.get(this.PATIENT_ADDRESS_FLATEXTRA).value;
        if (!!originalValue) {
            let newValue = originalValue.replace(new RegExp(this.experienceI18n.translate('modules.admissions.patient-data.confirm-without-address.no-number', undefined, 'Sin número'), 'g'), '');
            this.formAddress.patchValue({ [this.PATIENT_ADDRESS_FLATEXTRA]: newValue });
        }
    }

    createNewContactForm(contact?: PatientContact): FormGroup {
        let mainContact;
        const emailDisabled = this.case?.patient?.user?.active;

        if (!!this.patientSelected && this.patientSelected.contacts.length != 0) {
            mainContact = !!contact ? contact.isMainContact ? true : false : false; // Select radioButton mainConctat = true
        } else if (this.contacts.length == 0) {
            mainContact = true; // Unique element then is main
        } else {
            mainContact = false;
        }

        return this.formBuilder.group({
            [this.PATIENT_NEW_CONTACT_ID]: [!!contact ? contact.id : ''],
            [this.PATIENT_NEW_CONTACT_PHONE]: [!!contact ? contact.phoneNumber : '',], // [CustomValidators.required('Teléfono requerido')]
            [this.PATIENT_NEW_CONTACT_EMAIL]: [{ value: !!contact ? contact.email : '', disabled: emailDisabled }],
            [this.PATIENT_NEW_CONTACT_REFERENCE]: [!!contact ? contact.reference : ''],
            isMainContact: new FormControl({ value: mainContact, disabled: false }),
        });
    }

    addContact() {
        this.contacts.push(this.createNewContactForm());
        this.validMainContact();
    }

    removeContact(i: number) {

        if (this.contacts.length > 1 && this.contacts['controls'][i].value.isMainContact) {
            const swalWithCustomizeButtons = Swal.mixin({
                customClass: {
                    confirmButton: 'btnSwalConfirm',
                    cancelButton: 'btnSwalCancel'
                },
                buttonsStyling: true
            })
            swalWithCustomizeButtons.fire({
                title: this.experienceI18n.translate('modules.admissions.patient-data.remove-contact-modal.title', undefined, 'Atención'),
                text: this.experienceI18n.translate('modules.admissions.patient-data.remove-contact-modal.text', undefined, 'No puede eliminar un contacto principal, marque otro como principal y reintente'),
                icon: 'error'
            });
        } else {
            this.contacts.removeAt(i);
            this.validMainContact();
        }
    }

    validMainContact() {
        if (this.contacts.length == 1) { // Only one element, so it's main
            this.contacts.value[0].isMainContact = true;
            this.indexMainContact = 0;
        } else {
            this.indexMainContact = this.contacts.value.findIndex(e => e.isMainContact === true); // Update global index for mainContact
        }
    }

    changeMainContact() {
        this.contacts['controls'][this.indexMainContact]['controls'].isMainContact.value = false;
        this.contacts.value[this.indexMainContact].isMainContact = false;
        this.validMainContact();
    }

    selected(patient: Patient | PatientLight | string | PatchPatientBody) {
        // New Patient option selected
        if (this.isPatientInputParam) this.formPatient.reset();
        if (this.isPatientInputParam) this.contacts.clear();
        if (this.formPatient.disabled) {
            this.formPatient.enable();
            this.formAddress.enable();
        }

        this.formPatient.get(this.PATIENT_TYPEDOCUMENT).enable();
        this.formPatient.get(this.PATIENT_DOCUMENTNUMBER).enable();

        if (typeof patient === 'string') {
            // New patient
            this.btn_addContact_disabled = false;
            this.addContact();
        } else if (this.isPatientLight(patient)) {
            // Si es PatientLight, obtener los datos completos
            this.patientsService.getPatient(patient.id).subscribe((fullPatient: any) => {
                // Convertir PatientEntities a Patient si es necesario
                const completePatient = this.mapPatientEntitiesToPatient(fullPatient);
                this.selected(completePatient); // Llamar recursivamente con Patient completo
            });
        } else if (this.isPatient(patient)) {
            // Patient selected (Patient completo)
            if (this.parentComponent === 'admission-creation') {
                this.formPatient.get(this.PATIENT_TYPEDOCUMENT).disable();
                this.formPatient.get(this.PATIENT_DOCUMENTNUMBER).disable();
            }
            const fullPatient: Patient = patient;
            this.patientSelected = fullPatient;

            if (!!fullPatient?.address && !!fullPatient?.address.location) {
                this.actualPatientProvince = fullPatient.address.location.province;
                this.actualPatientLocation = fullPatient.address.location;
                this.selectProvince(this.actualPatientProvince.id);
            }

            //this.formPatient.get(this.PATIENT_TYPEDOCUMENT).disable();
            //this.formPatient.get(this.PATIENT_DOCUMENTNUMBER).disable();
            this.formPatient.patchValue({
                [this.PATIENT_TYPEDOCUMENT]: fullPatient?.typeDocument?.id.toString(),
                [this.PATIENT_DOCUMENTNUMBER]: fullPatient?.documentNumber != '0' ? fullPatient?.documentNumber : '',
                [this.PATIENT_NAME]: fullPatient?.name,
                [this.PATIENT_BIRTHDATE]: fullPatient?.birthDate,
                [this.PATIENT_AGE]: this.calculateAge(fullPatient?.birthDate),
                [this.PATIENT_SURNAME]: fullPatient?.surname,
            });
            this.formPatient.controls['gender'].patchValue((!!fullPatient && fullPatient.gender != '') ? fullPatient?.gender : 'S/E')
            this.formAddress.patchValue({
                [this.PATIENT_ADDRESS_FLAT]: fullPatient?.address?.flat,
                [this.PATIENT_ADDRESS_STREET]: fullPatient?.address?.street,
                // [this.PATIENT_ADDRESS_STREETNUMBER]: patient?.address?.streetNumber,
                [this.PATIENT_ADDRESS_FLOOR]: fullPatient?.address?.floor,
                [this.PATIENT_ADDRESS_FLATEXTRA]: fullPatient?.address?.flatExtra,
                [this.PATIENT_WITHOUT_STREET_NUMBER]: Boolean(fullPatient?.address?.withoutNumber === true)
                // TODO: Adapt location dynamic
                /* [this.PATIENT_ADDRESS_ZIPCODE]: patient?.address?.zipcode, */
            })

            // Load contacts
            if (!this.patientSelected.contacts) {
                this.patientSelected.contacts = [];
            }

            if (this.patientSelected.contacts.length != 0) {
                this.contacts.removeAt(0);
                this.loadManyContacts();
            } else {
                this.addContact();
                this.btn_addContact_disabled = true;
            }

            this.changeDetector.detectChanges();

            if (!this.isPatientInputParam) {

                this.casesService.getCases({ patientId: fullPatient.id, active: true, page: 0, size: 10 }).subscribe((casesPages) => {
                    let cases = casesPages.data;
                    if (cases.length != 0) {
                        this.caseActive = cases[0];
                        this.formPatientCaseActive = this.createFormCaseActive(this.caseActive);

                        this.openDialog('', this.patientCaseActive, { maxHeight: '95vh', minWidth: '35%', maxWidth: '35%' }, () => {
                            // Hacer algo cuando se cierra o nada
                        }, "p-0");
                    }
                })
            }
        }
        this.loadingPatient = false;
    }

    loadManyContacts() {

        this.btn_addContact_disabled = false;

        this.patientSelected.contacts.forEach((contact, index) => {
            if (this.patientSelected.mainContactId == contact.id) {
                this.indexMainContact = !!index ? index : 0; // Save global index contact main
                contact = { ...contact, isMainContact: true }
            } else if (!this.patientSelected.mainContactId) {
                this.indexMainContact = contact.id;
                contact = { ...contact, isMainContact: true }
            }
            this.contacts.push(this.createNewContactForm(contact))
        });
    }

    calculateNamePatient(element: Patient | PatientLight) {
        return element ? element.surname + ' ' + element.name : null;
    }

    calculateIdPatient(element: Patient | PatientLight) {
        return element ? element.id : null;
    }

    calculateNameLocation(location: Location) {
        return !!location ? location.name : '';
    }

    calculateIdLocation(location: Location) {
        return !!location ? location.id : '';
    }

    calculateNameProvince(province: Province) {
        return province ? province.name : null;
    }

    calculateIdProvince(province: Province) {
        return province ? province.id : null;
    }

    loadProvincesByName = (value: string) => {
        const sfp: ProvinceQPS = {
            name_like: value
        };
        return this.entitiesFacade.loadProvinces(sfp);
    }

    selectProvince(id: number) {
        let province = this.provincesOnSelect.find(province => province.id == id);
        if (!province) return;

        this.provinceSelected = province;
        this.formAddress.patchValue({
            [this.PATIENT_ADDRESS_STATE]: province.id,
        });
        this.formAddress.patchValue({
            [this.PATIENT_ADDRESS_LOCATION]: null
        })
        this._locations = this.entitiesFacade.loadLocations({ provinceId: province.id }).subscribe((locations: Location[]) => {
            if (!!locations) {
                this.locations = locations;
                if (!!this.actualPatientLocation) {
                    this.selectLocation(this.actualPatientLocation.id);
                }
            }
        })
        if (!!id && this.provincesOnSelect.length > 0) {
            this.selectedProvince = this.provinceSelected.name;

        }

        this.formAddress.patchValue({
            // limpia el selector de localidad
            [this.PATIENT_ADDRESS_LOCATION]: null,
            // limpia calle y número
            [this.PATIENT_ADDRESS_STREET]: '',
            [this.PATIENT_ADDRESS_STREETNUMBER]: '',
            [this.PATIENT_WITHOUT_STREET_NUMBER]: false,
            // opcional: piso y depto si quieres
            [this.PATIENT_ADDRESS_FLOOR]: '',
            [this.PATIENT_ADDRESS_FLAT]: '',
        });
    }

    selectLocation(id: number) {
        this.locationSelected = this.locations.find(l => l.id == id);
        if (!this.locationSelected) return;

        this.formAddress.patchValue({
            [this.PATIENT_ADDRESS_LOCATION]: this.locationSelected.id,
        });
        this.selectedCity = this.locationSelected.name;
        this.formAddress.get('zipCode').setValue(this.locationSelected.zipCode);
    }

    closeDialog() {
        this._dialogRef.close();
    }

    openDialog(title: string, template, style: { minWidth: string, maxHeight: string, maxWidth: string }, afterClosed?, templateClass?: string): void {
        let data = { template, title, templateClass: null };
        if (!!templateClass) {
            data.templateClass = templateClass;
        }
        this._dialogRef = this.dialog.open(DialogComponent, {
            disableClose: true,
            minWidth: style.minWidth,
            maxHeight: style.maxHeight,
            maxWidth: style.maxWidth,
            panelClass: 'custom-modalbox',
            data: data
        })
        this._dialogRef.afterClosed().subscribe(() => afterClosed());
    }


    createFormCaseActive(caseForPatient: Case) {
        return this.formBuilder.group({
            [this.PATIENT_NAME_CASE_ACTIVE]: [{ value: caseForPatient.id, disabled: true }],
            [this.PATIENT_OPERATOR_CASE_ACTIVE]: [{
                value: caseForPatient.operator
                    ? caseForPatient.operator.surname + ', ' + caseForPatient.operator.name
                    : '',
                disabled: true
            }]
        })
    }

    private navigateToAdmissionsAfterDialogsClose() {
        const navigateToAdmissions = () => {
            this.router.navigate([ROUTES.ADMISSIONS]);
        };

        if (this.dialog.openDialogs.length > 0) {
            this.dialog.afterAllClosed.pipe(take(1)).subscribe(() => {
                navigateToAdmissions();
            });
            this.dialog.closeAll();
            return;
        }

        navigateToAdmissions();
    }

    redirectToCase() {
        this._dialogRef.close();
        if (this.parentComponent == "admission-creation") {
            this.generalService.setGoBack({ route: ROUTES.ADMISSIONS_CREATE, title: this.experienceI18n.translate('modules.admissions.patient-data.patient-selector.dashboard', undefined, 'Dashboard') });
        } else {
            this.generalService.setGoBack({ route: ROUTES.CASES, title: this.experienceI18n.translate('modules.admissions.patient-data.patient-selector.casos', undefined, 'Casos') })
        }

        const url: string = ROUTES.CASES + '/' + (this.caseActive ? this.caseActive.id : this.closedCase.id);
        window.open(url, '_blank');
        if (this.parentComponent == "admission-creation") {
            this.returnToDashboard();
        }
    }

    calculateAge(birthDate?: Date): string {

        if (birthDate === undefined) {
            birthDate = this.patientBirthdate
        }
        if (birthDate != null)
            return this.patientAge = `${moment().diff(birthDate, 'years')} ${this.experienceI18n.translate('modules.admissions.patient-data.patient-selector.age-years', undefined, 'años')}`
        else {
            this.patientAge = '';
            return '';
        }
    }

    clickCancelEditPatient() {
        this.onClickCancelEditPatient.emit();
    }

    clickConfirmEditPatient() {
        const documentNumberControl = this.formPatient.get(this.PATIENT_DOCUMENTNUMBER);
        const documentNumber = documentNumberControl.value;
        const currentPatientId = this.case?.patient?.id ?? this.patientSelected?.id;

        // Sin cambios en el documento no hace falta chequear duplicados
        if (!documentNumber || !documentNumberControl.dirty) {
            this.validateDocumentNumber();
            this.onClickConfirmEditPatient.emit();
            this.onClickConfirm = true;
            return;
        }

        this.isValidatingDocumentNumber.emit(true);
        this.patientsService.getPatients({ document_number: documentNumber })
        .pipe(take(1))
        .subscribe(patients => {
            this.isValidatingDocumentNumber.emit(false);
            const duplicated = patients?.some(p => p.id !== currentPatientId);

            if (duplicated) {
                documentNumberControl.markAsTouched();
                this.formPatienValid = false;
                this.formPatientDataValid.emit(false);
                this.validateDocumentNumber();
                return;
            }

            this.onClickConfirmEditPatient.emit();
            this.onClickConfirm = true;
        });
    }

    addTask() {
        this.formSelectTask = this.createFormSelectTask();
        this.openDialog(this.experienceI18n.translate('modules.admissions.patient-data.add-task-dialog', undefined, 'Tipo de tarea'), this.selectTask, { maxHeight: '95vh', minWidth: '35%', maxWidth: '80%' }, () => {
        })
    }

    createFormSelectTask(): FormGroup {
        return this.formBuilder.group({
            radioButton: new FormControl({ value: '', disabled: false }, CustomValidators.required(this.experienceI18n.translate('modules.admissions.patient-data.select-task-form.validators.required', undefined, 'Debe seleccionar una opción')))
        })
    }

    clickCancelSelectTask() {
        this._dialogRef.close();
    }

    clickConfirmSelectTask() {
        let taskToCreate: PostRequisitionBody = {
            caseId: this.caseActive.id
        }
        let requisitionType = Object.values(RequisitionTypes).find(value => value == this.selectedTask);
        taskToCreate.requisitionTypeId = Object.values(RequisitionTypes).indexOf(requisitionType);
        this.requisitionFacade.addRequisition(taskToCreate).subscribe(requisition => {
            this.returnToDashboard();

            const swalWithCustomizeButtons = Swal.mixin({
                customClass: {
                    confirmButton: 'btnSwalConfirm',
                    cancelButton: 'btnSwalCancel'
                },
                buttonsStyling: true
            })

            swalWithCustomizeButtons.fire({
                text: this.experienceI18n.translate('modules.admissions.patient-data.confirm-select-task-modal.text', undefined, 'Tarea creada correctamente'),
                icon: 'success',
            });
        });
        // TODO: llamar al endpoint
    }

    radioButtonSelected(event) {
        this.selectedTask = event.value
    }

    returnToDashboard() {
        this.navigateToAdmissionsAfterDialogsClose();
    }

    isRequisition(casee: Case) {
        return casee.requested;
    }

    admissionDocumentNumberValidation(documentNumber: string) {
        let patientId
        this.patientsService.getPatients({ document_number: documentNumber }).subscribe(p => {
            if (!!p && !!p[0]) {
                patientId = p[0].id;
            }
            if (!!patientId) {
                this.casesService.getCases({ active: true, patientId: patientId, page: 0, size: 10 }).subscribe((casesPages) => {
                    let caseActive = casesPages.data
                    if (!!caseActive) {
                        this.patientSelected = caseActive[0].patient;
                        this.caseActive = caseActive[0];
                        this.formPatientCaseActive = this.createFormCaseActive(this.caseActive);

                        this.openDialog('', this.patientCaseActive, { maxHeight: '95vh', minWidth: '35%', maxWidth: '35%' }, () => {
                            // Hacer algo cuando se cierra o nada
                        }, "p-0");
                    }
                })
            }
        })
    }

    caseDocumentNumberValidation(documentNumber: string) {
        let patientId
        this.isValidatingDocumentNumber.emit(true);
        this.patientsService.getPatients({ document_number: documentNumber }).subscribe(p => {
            if (!!p && !!p[0]) {
                patientId = p[0].id
            }
            if (!!patientId) {
                this.casesService.getCases({ patientId: patientId, page: 0, size: 10 }).subscribe(casesPages => {
                    let cases = casesPages.data
                    let activeCases = cases?.filter(c => c.active == true);
                    let closedCases = cases?.filter(c => c.active == false);
                    let closedCaseId = closedCases[0]?.id;
                    if (!!cases && activeCases.length == 0 && closedCases.length != 0) {
                        this.casesService.getCase(closedCaseId, { withProvisions: false }).subscribe(c => {
                            this.caseActive = null
                            this.closedCase = c;
                            let lastState = this.closedCase?.states[this.closedCase?.states.length - 1];
                            this.closedCaseDate = moment(lastState?.stateChangeDate).format('DD/MM/YYYY');
                            this.isValidatingDocumentNumber.emit(false);
                            this.emitCase.emit(this.closedCase);
                            this.patientSelected = this.closedCase.patient;
                            if (this.onClickConfirm) {
                                this.formPatientCaseActive = this.createFormCaseActive(this.closedCase);
                                this.openDialog('', this.patientCaseActive, { maxHeight: '95vh', minWidth: '35%', maxWidth: '35%' }, () => {
                                }, "p-0");
                            }

                        })
                    } else if (!!cases && activeCases.length != 0 && activeCases[0].id != this.case.id) {
                        this.closedCase = null
                        this.patientSelected = activeCases[0].patient;
                        this.caseActive = activeCases[0];
                        this.formPatientCaseActive = this.createFormCaseActive(this.caseActive);
                        this.formPatienValid = false;
                        this.formPatientDataValid.emit(false);
                        this.formPatient.get(this.PATIENT_DOCUMENTNUMBER).setValidators(CustomValidators.required(this.experienceI18n.translate('modules.admissions.patient-data.case-document-number-validation.validators.required', undefined, 'No se puede continuar con el documento seleccionado')))
                        this.emitCase.emit(this.caseActive);
                        this.openDialog('', this.patientCaseActive, { maxHeight: '95vh', minWidth: '35%', maxWidth: '35%' }, () => {
                            // Hacer algo cuando se cierra o nada
                        }, "p-0");
                        this.isValidatingDocumentNumber.emit(false)
                    } else {
                        this.noCaseFound();
                        this.formPatienValid = true;
                        this.formPatientDataValid.emit(true);
                    }
                })
            } else {
                this.noCaseFound();
            }
        })
    }

    validateDocumentNumber() {
        this.isValidatingDocumentNumber.emit(true)
        const documentNumber = this.formPatient.get(this.PATIENT_DOCUMENTNUMBER).value;
        if (!!documentNumber && !/^[0-9]*$/.test(documentNumber)) {
            this.formPatient.get(this.PATIENT_DOCUMENTNUMBER).setErrors({ pattern: this.experienceI18n.translate('modules.admissions.patient-data.el-documento-debe-contener-solo-numeros', undefined, 'El documento debe contener solo números.') });
            this.isValidatingDocumentNumber.emit(false);
            return;
        }
        if (this.parentComponent == "admission-creation" && !!documentNumber && documentNumber.length >= 7 && parseInt(documentNumber) > 1000000) {
            this.admissionDocumentNumberValidation(documentNumber);
        } else if (this.parentComponent == "patient-detail" && !!documentNumber && documentNumber.length >= 7 && parseInt(documentNumber) > 1000000 && this.formPatient.get(this.PATIENT_DOCUMENTNUMBER).dirty) {
            this.caseDocumentNumberValidation(documentNumber);
        } else {
            this.noCaseFound()
        }
        this.formPatient.get(this.PATIENT_DOCUMENTNUMBER).setErrors(null);
    }

    noCaseFound() {
        this.closedCase = null;
        this.caseActive = null;
        this.emitCase.emit(null);
        this.isValidatingDocumentNumber.emit(false);
    }

    confirmChanges() {
        this.confirmChangesEmitter.emit()
    }

    getContactFormGroup(index: number): FormGroup {
        return this.contacts.at(index) as FormGroup;
    }

    getFormAddressGroup() {
        return this.formAddress as FormGroup
    }


    onConfirmWithoutAddress(event: boolean): void {
        if (event === true || event === false) {
            // Previous values
            const currentWithoutNumber = this.formAddress.get(this.PATIENT_WITHOUT_STREET_NUMBER)?.value;
            const currentFlatExtra = this.formAddress.get(this.PATIENT_ADDRESS_FLATEXTRA)?.value || "";

            let newFlatExtra: string;

            if (event) {
                this.patientWithoutNumberCheck = true;
                // Add "Sin número"
                // if (currentFlatExtra.indexOf('Sin número') === -1) {
                //     newFlatExtra = currentFlatExtra
                //         ? `Sin número ${currentFlatExtra}`
                //         : 'Sin número';
                // } else {
                newFlatExtra = currentFlatExtra;
                // }
            } else {
                this.patientWithoutNumberCheck = false;
                //Delete "Sin número"
                newFlatExtra = currentFlatExtra.replace('Sin número', '').trim();
            }
            if (currentWithoutNumber === event && currentFlatExtra === newFlatExtra) {
                return;
            }

            // Solo si en verdad cambian, actualizo
            this.formAddress.patchValue({
                [this.PATIENT_WITHOUT_STREET_NUMBER]: event,
                [this.PATIENT_ADDRESS_FLATEXTRA]: newFlatExtra
            });
        }
    }
    isPatient(value: Patient | PatchPatientBody | string): value is Patient {
        return (
            typeof value === 'object' &&            // 1) Verifica que sea un objeto
            value !== null &&                      // 2) ...y no sea null
            'address' in value &&                  // 3) ...y tenga la propiedad 'address'
            typeof (value as any).address === 'object' &&
            (value as any).address !== null        // 4) ...y que 'address' sea un objeto no null
        );
    }

    isPatientLight(value: any): value is PatientLight {
        return (
            typeof value === 'object' &&
            value !== null &&
            'id' in value &&
            'name' in value &&
            'surname' in value &&
            !('address' in value) // PatientLight no tiene address
        );
    }

    mapPatientEntitiesToPatient(patientEntities: PatientEntities): Patient {
        // Mapeo de PatientEntities a Patient si es necesario
        return {
            id: patientEntities.id,
            name: patientEntities.name,
            surname: patientEntities.surname,
            typeDocument: patientEntities.typeDocument as TypeDocument,
            documentNumber: patientEntities.documentNumber,
            address: patientEntities.address as unknown as Address,
            gender: patientEntities.gender,
            birthDate: patientEntities.birthDate,
            email: patientEntities.email,
            phoneNumber: '', // No viene en PatientEntities
            active: true,
            affiliationNumber: '', // No viene en PatientEntities
            contacts: patientEntities.contacts as unknown as PatientContact[]
        } as Patient;
    }


}
